module.exports = __webpack_public_path__ + "static/media/compoundwirecutter-video.ce3b3283.avi";